import { Component, Ref, Watch } from 'vue-property-decorator'
import { BaseForm } from '@/mixins/Base.tsx'
import {
  FormRenderServiceProxy,
  FileInfoVO,
  FolderServiceProxy,
} from '@/service-proxies/app-v2/dnc.service-proxies'

import { ServiceProxy as ObsFileServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'

import ViewDetail from './ViewDetail/index.vue'
const frsp = new FormRenderServiceProxy()
const ofsp = new ObsFileServiceProxy()
const fsp = new FolderServiceProxy()
const CODE = 'DNC_RESOURCE'
import FileTable from './FileTable'
import { Tree } from 'ant-design-vue'

@Component({
  components: {
    ViewDetail
  },
})
export default class CreateForm extends BaseForm {
  @Ref() aTree: Tree
  public programs: FileInfoVO[] = []
  public documents: FileInfoVO[] = []
  public visible = { uploadMethod: false, fileTree: false }
  public currentfileType = 1
  public treeData: any[] = []
  public originalFiles: any[] = []
  public treeFiles: any[] = []
  public detailvisible = false
  public detail = {}
  loading = { upload: false }

  @Watch('visible.fileTree')
  resetFiles(val) {
    if (val) {
      this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
      this.originalFiles = []
      this.treeFiles = []
    }
  }

  created() {
    this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
    this.loadSchema()
  }

  titleNode(text) {
    return (
      <div style="border-left: 4px solid #3a7fbc; color: #3a7fbc; padding-left: 8px; margin-bottom: 16px;">{text}</div>
    )
  }

  uploadNode(text) {
    return (
      <div class="add" onClick={this.startUpload.bind(this, text === this.$t('page_resource_pool_job_gram') ? 1 : 2)}>
        <a-icon type="plus" />
        &nbsp;
        {this.$t('page_resource_pool_add')}
        {text}
      </div>
    )
  }

  async loadSchema() {
    try {
      const { schema } = await frsp.findFormSchema(CODE)
      this.schema = schema
    } catch (e) {
      console.log(e.message)
    }
  }

  startUpload(fileType) {
    this.currentfileType = fileType
    this.visible.uploadMethod = true
  }

  handleDelete({ record, index }) {
    this[record.fileType === 1 ? 'programs' : 'documents'].splice(index, 1)
  }

  uploadOnline() {
    this.visible.uploadMethod = false
    this.visible.fileTree = true
    this.$nextTick(() => {
      const tree = this.aTree.$el
      const firstNode: any = tree.getElementsByClassName('ant-tree-switcher')
      if (firstNode[0]) {
        firstNode[0].click()
      }
    })
  }

  uploadOffline() {
    this.visible.uploadMethod = false
    const upload = document.createElement('input')
    upload.type = 'file'
    upload.multiple = true
    upload.onchange = async (e: any) => {
      const files: any = e.path[0].files
      files.forEach(async file => {
        const res = await (await ofsp.putFileUsingPOST({fileName:file.name,data:file})).data
        const ossfile = await (await ofsp.statFileUsingGET(res.name)).data

        this[this.currentfileType === 1 ? 'programs' : 'documents'].push({
            contentLength: ossfile.length.toString(),
            contentMd5: ossfile.hash,
            contentType: ossfile.contentType,
            displayName: file.name,
            objectKey: res.name,
            suffix: file.name.lastIndexOf(".") > 0 ? file.name.substring(file.name.lastIndexOf(".") + 1) : "",
            fileType: this.currentfileType,
          } as FileInfoVO)
      })

      this.loading.upload = false
    }
    upload.click()
  }

  handleTreeFile() {
    const files = this.originalFiles
      .filter(item => {
        return this.treeFiles.includes(item.id)
      })
      .map(item => {
        return {
          contentLength: item.contentLength,
          contentMd5: item.contentMd5,
          contentType: item.contentType,
          displayName: item.name,
          objectKey: item.objectKey,
          suffix: item.suffix,
          fileType: this.currentfileType,
        } as FileInfoVO
      })
    const realFiles = []
    if (this.currentfileType === 1) {
      for (let f of files) {
        const flag = this.programs.find(item => item.contentMd5 === f.contentMd5)
        if (!flag) {
          realFiles.push(f)
        } else {
          this.$message.info(this.$t('page_resource_pool_repeat'))
        }
      }
      this.programs = [...this.programs, ...realFiles]
    }
    if (this.currentfileType === 2) {
      for (let f of files) {
        const flag = this.documents.find(item => item.contentMd5 === f.contentMd5)
        if (!flag) {
          realFiles.push(f)
        } else {
          this.$message.info(this.$t('page_resource_pool_repeat'))
        }
      }
      this.documents = [...this.documents, ...realFiles]
    }
    this.visible.fileTree = false
  }

  onLoadData(treeNode) {
    return new Promise(resolve => {
      if (treeNode.dataRef.children) {
        resolve()
        return
      }
      fsp.folderList(treeNode.dataRef.key, '').then(res => {
        this.originalFiles = [...this.originalFiles, ...res.fileList]
        let files, folders
        files = res.fileList.map(file => ({ title: file.name, key: file.id, isLeaf: true }))
        folders = res.folderList.map(folder => ({ title: folder.name, key: folder.id, checkable: false }))
        treeNode.dataRef.children = [...files, ...folders]
        this.treeData = [...this.treeData]
        resolve()
      })
    })
  }
  openPreview(record){
    this.detail = record
    this.detailvisible = true
  }
  closeDetail(){
    this.detailvisible = false
  }
  render() {
    return (
      <div class="update-form">
        {this.titleNode(this.$t('page_resource_pool_base'))}
        <d-form schema={this.schema} cols={2} ref="dForm" />
        <a-row gutter={16}>
          <a-col span={12}>
            {this.titleNode(this.$t('page_resource_pool_job_gram'))}
            <FileTable canView={false} data={this.programs} onDelete={this.handleDelete} onPreview={this.openPreview} />
            {this.uploadNode(this.$t('page_resource_pool_job_gram'))}
          </a-col>
          <a-col span={12}>
            {this.titleNode(this.$t('page_resource_pool_art'))}
            <FileTable canView={false} data={this.documents} onDelete={this.handleDelete} onPreview={this.openPreview} />
            {this.uploadNode(this.$t('page_resource_pool_art'))}
          </a-col>
        </a-row>

        <a-modal
          width={320}
          title={null}
          footer={null}
          visible={this.visible.uploadMethod}
          closable={false}
          centered={true}
          maskClosable={false}
        >
          <div style="display: flex; margin: 40px 0">
            <div style="display: flex; flex-direction: column; align-items: center; width: 50%;">
              <a-icon type="file" style="color: #4a90e2; font-size: 40px" onClick={this.uploadOnline} />
              <span>{this.$t('page_resource_pool_my_doc')}</span>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; width: 50%;">
              <a-icon type="desktop" style="color: #4a90e2; font-size: 40px" onClick={this.uploadOffline} />
              <span>{this.$t('page_resource_pool_local_doc')}</span>
            </div>
          </div>
          <div style="text-align: center">
            <a-button onClick={() => (this.visible.uploadMethod = false)}>{this.$t('close')}</a-button>
          </div>
        </a-modal>
        <a-modal
          title={null}
          okText={this.$t('page_resource_pool_add')}
          cancelText={this.$t('close')}
          onOk={this.handleTreeFile}
          onCancel={() => (this.visible.fileTree = false)}
          visible={this.visible.fileTree}
          closable={false}
          destroyOnClose={true}
          maskClosable={false}
        >
          <a-tree
            v-model={this.treeFiles}
            ref="aTree"
            checkable
            loadData={this.onLoadData}
            treeData={this.treeData}
            showLine
          />
        </a-modal>
        <view-detail visible={this.detailvisible} item={this.detail} onClose={this.closeDetail}/>
        <a-spin
          size="large"
          spinning={this.loading.upload}
          style="position: absolute; left: 0; top: 0; right: 0; bottom: 0; line-height: 600px; background: rgba(0, 0, 0, .1); z-index: 100"
        />
      </div>
    )
  }
}
